<template>
    <!-- 导航 -->
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">关于我们</span>
        </template>
    </NavBar>

    <main>

        <div class="top">
            <img src="@/assets/images/logo.png" alt="">
            <p>新华数藏</p>
            <p class="versions">版本号：V1.0.0</p>
        </div>
        <div class="information-bar">
            <!-- <router-link to="/agreement/introduce">
                <li>
                    <div class="title">
                        <img src="@/assets/images/MyCompany.png" alt="" />
                        <span>公司介绍</span>
                    </div>
                    <van-icon name="arrow" color="#343A40" size="14" />
                </li>
            </router-link> -->
            <router-link to="/agreement/user">
                <div class="title">
                    <img src="@/assets/images/MyAgreement.png" alt="" />
                    <span>用户协议</span>
                </div>
                <van-icon name="arrow" color="#343A40" size="14" />
            </router-link>
            <router-link to="/agreement/policy">
                <div class="title">
                    <img src="@/assets/images/MyPrivacy.png" alt="" />
                    <span>隐私政策</span>
                </div>
                <van-icon name="arrow" color="#343A40" size="14" />
            </router-link>
        </div>
        <div class="logout" v-if="! xinhua">
            <span class="btn active" @click="logout">退出登录</span>
        </div>
    </main>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>